(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
})((function () { 'use strict';

    window.carbon = window.carbon || {};
    (function(){
        if (!document.querySelector('.partner-contact-popup')) return;
        carbon.updatePartnerContactPopup = function(popupElem, data) {
            if (!popupElem || !popupElem.querySelector('form')) return;
            var nameFieldElem = popupElem.querySelector('input[name="partner_name"]');
            var emailFieldElem = popupElem.querySelector('input[name="partner_email"]');
            var headlineElem = popupElem.querySelector('.partner-contact-popup__header-headline');
            var locationElem = popupElem.querySelector('.partner-contact-popup__header-location');
            nameFieldElem.setAttribute('value', '');
            emailFieldElem.setAttribute('value', '');
            if (headlineElem) headlineElem.innerHTML = '';
            if (locationElem) locationElem.innerHTML = '';
            // set form fields and content
            if (data.name) {
                nameFieldElem.setAttribute('value', data.name);
                if (headlineElem) headlineElem.innerHTML = data.name;
            }
            if (data.email) emailFieldElem.setAttribute('value', data.email);
            if (data.location && locationElem) locationElem.innerHTML = data.location;
        };
        var postGridElems = document.querySelectorAll('.grid-cols'); // updated to support component layout
        if (postGridElems) postGridElems.forEach(function(postGridElem){
            postGridElem.addEventListener('click', function(e){
                if (!e.target.matches('.site-btn')) return;
                var postElem = e.target.closest('.post-grid__post--partner');
                if (!postElem) return;
                var popupElem = document.getElementById(e.target.hash.substr(1));
                carbon.updatePartnerContactPopup(popupElem, {
                    name: postElem.getAttribute('data-partner-name'),
                    email: postElem.getAttribute('data-partner-email'),
                    location: postElem.querySelector('.post-grid__post-meta').innerText,
                });
                // TODO: clean up selectors to allow for non-"post-grid" elements
              }, false);
        });
    })();

    (function(){
        /**
         * Switch partner popup section
         *
         * Popup links must include "data-popup-section" attribute
         */
        document.body.addEventListener('click', function(e){
            // required
            var linkElem = e.target.closest('[href^="#partner-popup"]');
            if (!linkElem) return;
            // required
            var popupSection = linkElem.getAttribute('data-popup-section');
            if (!popupSection) return;
            e.preventDefault();
            var popupSelector = linkElem.getAttribute('href');
            var popupElem = document.querySelector(popupSelector);
            // switch popup sections
            if ('form' == popupSection ) popupElem.classList.add('form-on');
            else popupElem.classList.remove('form-on');
        }, true);
    })();

    /**
     * Reset partner popup section on popup close
     *
     * This means that [ data-popup-section="details" ] does not need to be explicitly used.
     */
    jQuery(function($){
        $('[href^="#partner-popup"]').on('mfpAfterClose', function(e) {
            if (!$.magnificPopup.instance.st.el[0]) return;
            var popupSelector = $.magnificPopup.instance.st.el[0].getAttribute('href');
            var popupElem = document.querySelector(popupSelector);
            if (popupElem) popupElem.classList.remove('form-on');
        });
    });

}));
